import React from 'react'
import style from "./svg.module.css";
import svgpic from '../../img/svg1.svg'


const Svg1 = () => {
  return (
    <div>
         <div className={style.svgimg}
        data-aos="slide-left" data-aos-duration="6000">
          <img src={svgpic} alt='svg'/>
        </div>
    </div>
  )
}

export default Svg1